import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantAgendaModulesRoot = () => {
  useProtected();

  return <Outlet />;
};

export { AgendaModulePage } from "./AgendaModule";
export { AgendaModulesPage } from "./AgendaModules";
